"use strict";
import React from "react";
import CookieManager from "../../utilities/CookieManager";
import ModalDialog from "../../controls/ModalDialog";
import { COOKIE_VALUE_SUPPRESS as SuppressValue } from "../../utilities/Constants";
import Button from "@p1s/p1s-common-react/Button";
import CheckBox from "../../controls/CheckBox";
import bowser from 'bowser';

class UnsupportedBrowserReminderDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show : false,
            dontShowMeAgain : false
        };

        this.onDontShowMeAgainClick = this.onDontShowMeAgainClick.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onRemindMeLater = this.onRemindMeLater.bind(this);

        var value = CookieManager.getUnsupportedBrowsersCookie();
        if (value != undefined){
            this.state.show = value != SuppressValue;
        }
        else {
            this.state.show = false;
        }
        if (this.state.show){
            this.props.getDownloadBrowsersInfo(this.props.getDownloadBrowsersInfo);
        }
    }

    onDontShowMeAgainClick(e) {
        this.setState({ dontShowMeAgain: e.target.checked });
    }

    onClose() {
        // set suppress cookie with session lifetime
        CookieManager.setUnsupportedBrowsersCookieSuppressValue(false, false);
        this.state.show = false;
        this.setState(this.state);
    }

    onRemindMeLater() {
        // set suppress cookie value
        CookieManager.setUnsupportedBrowsersCookieSuppressValue(true, this.state.dontShowMeAgain);
        this.setState({ show: false });
    }

    render() {

        if(bowser.msie && bowser.version < 9) {
            return (<h4>
                <span style={{ backgroundColor: '#f44336' }}>We've noticed that you're using a browser that it is out of date or unsupported. In order to best view Sentri7 and all its features, upgrade your browser to the latest version.
                </span></h4>);
        }

        var icons = this.props.browserInfo.map((item, i)=> {
            return (
                <div key = {item.Name} className="col-md-4">
                    <a title={item.LinkText} href={item.DownloadPageUrl}>
                        <img src={item.ImageLink} />
                        <br/>{item.LinkText}
                    </a>
                </div>
            );
        });

        const buttons = [];
        var content =
        <div id="rootDiv">

            <div id = "contentText">
                <span>We've noticed that you're using a browser that it is out of date or unsupported. In order to best view Sentri7 and all its features, upgrade your browser to the latest version by choosing the icon below.</span>
            </div>
            <div id="browserDownloadBlock" className="textAlignCenter col-md-12">
                {icons}
            </div>
            <div id= "unsupportedBrowserDialogFooter" className="col-md-12">
                <div className="col-md-7">
                    <div className="margintop15">
                        <CheckBox id="dontShow"
                            checked={this.state.dontShowMeAgain}
                            onChange={(e) => this.onDontShowMeAgainClick(e) }
                            title="Do not show this message again"/>
                    </div>
                </div>
                <div className="col-md-5">
                    <Button className="btn btn-primary" onClick={this.onRemindMeLater} id="remindMe" tabIndex="1">REMIND ME LATER</Button>
                </div>
            </div>
        </div>;
        return (
            <div id="UnsupportedBrowserReminderDialog">
                <ModalDialog id="unsupportedBrowserReminderDialogModal"
                    title="Upgrade your browser"
                    content={content}
                    buttons={buttons}
                    onDocumentClose={() => this.onClose()}
                    show={this.state.show}
                />
            </div>
        );
    }
}

UnsupportedBrowserReminderDialog.propTypes = {

};

export default UnsupportedBrowserReminderDialog;
